import { Link } from "react-router-dom";
import { TEST_IDS } from "../constants/testIds";

export default function Login() {
  const startGoogleAuth = () => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    const redirectUrl = window.location.origin + "/auth/callback";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  return (
    <div className="min-h-[80vh] grid md:grid-cols-2">
      <div className="hidden md:block relative bg-[#0B1F3A]">
        <img
          src="https://images.unsplash.com/photo-1764160233831-694591688066?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzNTl8MHwxfHNlYXJjaHwyfHxtb2Rlcm4lMjBjb3Jwb3JhdGUlMjBvZmZpY2UlMjBza3lsaW5lfGVufDB8fHx8MTc4MzI3NTM1Nnww&ixlib=rb-4.1.0&q=85"
          alt=""
          className="absolute inset-0 w-full h-full object-cover opacity-25"
        />
        <div className="relative p-16 h-full flex flex-col justify-between text-[#F8F7F2]">
          <div className="eyebrow" style={{ color: "#D4AF37" }}>Investor Portal</div>
          <div>
            <h2 className="font-display text-5xl leading-tight">
              Confidential access to strategy briefings, mandate updates, and secure data rooms.
            </h2>
            <p className="mt-6 text-[#F8F7F2]/70 max-w-md">
              Sign in with your invited Google account to access portfolio updates,
              private materials, and the AI investment banker desk.
            </p>
          </div>
        </div>
      </div>

      <div className="flex items-center justify-center p-8 md:p-16">
        <div className="w-full max-w-md">
          <div className="eyebrow">Sign In</div>
          <h1 className="font-display text-4xl mt-4 text-[#0B1F3A]">Investor & Team Login</h1>
          <p className="mt-4 text-body text-sm">
            First Providence Capital uses invite-based Google authentication. Only pre-approved
            counterparties and team members can access the portal.
          </p>

          <button
            onClick={startGoogleAuth}
            data-testid={TEST_IDS.auth.google}
            className="mt-10 w-full h-14 border border-[#0B1F3A] text-[#0B1F3A] hover:bg-[#0B1F3A] hover:text-[#F8F7F2] flex items-center justify-center gap-3 text-sm uppercase tracking-[0.22em] font-medium transition"
          >
            <GoogleGlyph /> Continue with Google
          </button>

          <div className="mt-10 text-xs text-[#5F6B7A]">
            Not yet invited? <Link to="/contact" className="text-[#0B1F3A] gold-underline">Request access</Link> from our investor relations team.
          </div>
        </div>
      </div>
    </div>
  );
}

function GoogleGlyph() {
  return (
    <svg width="18" height="18" viewBox="0 0 48 48">
      <path fill="#EA4335" d="M24 9.5c3.54 0 6.72 1.22 9.22 3.6l6.85-6.85C35.9 2.38 30.47 0 24 0 14.62 0 6.51 5.38 2.56 13.22l7.98 6.19C12.43 13.72 17.74 9.5 24 9.5z" />
      <path fill="#4285F4" d="M46.98 24.55c0-1.57-.15-3.09-.38-4.55H24v9.02h12.94c-.58 2.96-2.26 5.48-4.78 7.18l7.73 6c4.51-4.18 7.09-10.36 7.09-17.65z" />
      <path fill="#FBBC05" d="M10.53 28.59c-.48-1.45-.76-2.99-.76-4.59s.27-3.14.76-4.59l-7.98-6.19C.92 16.46 0 20.12 0 24c0 3.88.92 7.54 2.56 10.78l7.97-6.19z" />
      <path fill="#34A853" d="M24 48c6.48 0 11.93-2.13 15.89-5.81l-7.73-6c-2.15 1.45-4.92 2.3-8.16 2.3-6.26 0-11.57-4.22-13.47-9.91l-7.98 6.19C6.51 42.62 14.62 48 24 48z" />
    </svg>
  );
}
